/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Studyprograms_Study_Protestant_Theology24Inputs */

const en__field__enum_studyprograms_study_protestant_theology24 = /** @type {(inputs: _Field__Enum_Studyprograms_Study_Protestant_Theology24Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protestant Theology`)
};

const de__field__enum_studyprograms_study_protestant_theology24 = /** @type {(inputs: _Field__Enum_Studyprograms_Study_Protestant_Theology24Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evangelische Theologie`)
};

/**
* | output |
* | --- |
* | "Protestant Theology" |
*
* @param {_Field__Enum_Studyprograms_Study_Protestant_Theology24Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_studyprograms_study_protestant_theology24 = /** @type {((inputs?: _Field__Enum_Studyprograms_Study_Protestant_Theology24Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Studyprograms_Study_Protestant_Theology24Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_studyprograms_study_protestant_theology24(inputs)
	return de__field__enum_studyprograms_study_protestant_theology24(inputs)
});
export { _field__enum_studyprograms_study_protestant_theology24 as "_field__enum_studyPrograms_STUDY_PROTESTANT_THEOLOGY" }